'use strict';

angular.module('systemOwnerReviewControllers')

.controller('SystemOwnerAuthUserController', ['$scope', '$state', '$stateParams', 'authLogin', 'currentPeriod', 'nextProcessStep', function ($scope, $state, $stateParams, authLogin, currentPeriod, nextProcessStep) {

    $scope.currentPeriod = currentPeriod;
    $scope.authLogin = authLogin;

    if (_.isEmpty($scope.currentPeriod)) {
        $state.go('systemOwnerReview.noReview', null,
                  { reload: true, location: 'replace' });
        return;
    }

    if ($state.is('systemOwnerReview.authUser')) {
        if (nextProcessStep.IsComplete) {
            $state.go('systemOwnerReview.authUser.completed', { authLogin: authLogin },
                     { reload: true, location: 'replace' });
        } else {
            $state.go('systemOwnerReview.authUser.gettingStarted', { authLogin: authLogin },
                      { reload: true, location: 'replace' });
        }

        return;
    }

    $scope.beginReview = function (nextProcessStep) {
        var nextRoute = 'systemOwnerReview.authUser.confirmSystemOwnershipExplanation';

        if (nextProcessStep.Code === 'DecommissionSystems') {
            nextRoute = 'systemOwnerReview.authUser.decommissionSystemsExplanation';
        }
        else if (nextProcessStep.Code === 'ReviewUniquePermissions') {
            nextRoute = 'systemOwnerReview.authUser.reviewUniquePermissionsExplanation';
        }

        $state.go(nextRoute, { authLogin: authLogin },
                  { reload: true });
    }

    $scope.goToConfirmSystemOwnership = function () {
        $state.go('systemOwnerReview.authUser.confirmSystemOwnership', { authLogin: authLogin },
                  { reload: true });
    }

    $scope.goToDecommissionSystems = function () {
        $state.go('systemOwnerReview.authUser.decommissionSystems', { authLogin: authLogin },
                  { reload: true });
    }

    $scope.goToUniquePermissions = function () {
        $state.go('systemOwnerReview.authUser.reviewUniquePermissions', { authLogin: authLogin },
                  { reload: true });
    }
}]);